import { render, staticRenderFns } from "./suppliers.vue?vue&type=template&id=1fc31a78&scoped=true"
import script from "./suppliers.vue?vue&type=script&lang=js"
export * from "./suppliers.vue?vue&type=script&lang=js"
import style0 from "./suppliers.vue?vue&type=style&index=0&id=1fc31a78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc31a78",
  null
  
)

export default component.exports